import { type ComponentChildren } from 'preact';

interface AlertProps {
  type: 'info' | 'warning' | 'error' | 'success';
  title?: string;
  children: ComponentChildren;
  className?: string;
}

export function Alert({
  type,
  title,
  children,
  className = '',
}: AlertProps): JSX.Element {
  const typeStyles = {
    info: 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 text-blue-800 dark:text-blue-200',
    warning: 'bg-yellow-50 dark:bg-yellow-900/20 border-yellow-200 dark:border-yellow-800 text-yellow-800 dark:text-yellow-200',
    error: 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800 text-red-800 dark:text-red-200',
    success: 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800 text-green-800 dark:text-green-200',
  };

  const titleStyles = {
    info: 'text-blue-900 dark:text-blue-100',
    warning: 'text-yellow-900 dark:text-yellow-100',
    error: 'text-red-900 dark:text-red-100',
    success: 'text-green-900 dark:text-green-100',
  };

  return (
    <div className={`border-l-4 p-4 rounded transition-colors duration-200 ${typeStyles[type]} ${className}`}>
      {title && <p className={`font-semibold mb-2 ${titleStyles[type]}`}>{title}</p>}
      <div className="text-sm">{children}</div>
    </div>
  );
}
